import { AbilityBuilder, createMongoAbility } from '@casl/ability'
import { ADMIN, MANAGER, PARTNER_TYPE, REPORT, RIGHTS_HOLDER_TYPE } from './selfAccounts'
import { COMBINED_CAMPAIGN_EDIT } from './forms'
import { ROUTES } from './routes'

export const RIGHTS_HOLDER_FILE_TYPES_LIST = 'rightsHolderFileTypesList'
export const PARTNER_FILE_TYPES_LIST = 'partnerFileTypesList'
export const OUTSTANDING_ACTIONS_NOTIFICATION = 'outstandingActionsNotification'
export const RIGHT = 'right'
export const CAMPAIGN_BUDGET_SECTION = 'campaignBudgetSection'
export const LINE_ITEM_BUDGET_SECTION = 'lineItemBudgetSection'
export const ON_SITE_AD_SERVER_SETTINGS_PAGE = 'onSiteAdServerSettingsPage'
export const AD_APPROVERS_LIST = 'adApproversList'
export const RIGHT_HOLDER_ACCOUNT_PROFILE = 'rightHolderAccountProfile'
export const RIGHTS_WITH_DRAFT_STATUS = 'rightsWithDraftStatus'
export const RIGHT_STATUS = 'rightStatus'
export const CALENDAR_EVENTS = 'CalendarEvents'
export const GAM_LINE_ITEM_ADVANCED_SETTINGS = 'gamLineItemAdvancedSettings'

export default function definePermissionsFor(accountType, role) {
  const { can, build } = new AbilityBuilder(createMongoAbility)

  if (accountType === RIGHTS_HOLDER_TYPE) {
    can('manage', [
      RIGHTS_HOLDER_FILE_TYPES_LIST,
      PARTNER_FILE_TYPES_LIST,
      OUTSTANDING_ACTIONS_NOTIFICATION,
      RIGHT,
      RIGHT_HOLDER_ACCOUNT_PROFILE
      // GAM_LINE_ITEM_ADVANCED_SETTINGS
    ])
    can('update', [CAMPAIGN_BUDGET_SECTION, LINE_ITEM_BUDGET_SECTION])
    can('read', [RIGHTS_WITH_DRAFT_STATUS, ROUTES.chat])
    can('update', [RIGHT_STATUS])
    if (role === REPORT) {
    } else if (role === MANAGER) {
      can('manage', [
        'RightsTeamManage',
        'PartnerAccounts',
        'SettingsPartnerships',
        'SettingsPartnerTeam',
        'SettingsPagesAndIdentities',
        'SettingsMargins',
        'Campaign'
      ])
      can('create', 'Audience')
    } else if (role === ADMIN) {
      can('manage', [
        'InternalAds',
        'SettingsRightsHolderSection',
        'RightsTeamManage',
        'PartnerAccounts',
        'SettingsPartnerships',
        'SettingsPartnerTeam',
        'SettingsPagesAndIdentities',
        'SettingsMargins',
        'Campaign',
        AD_APPROVERS_LIST
      ])
      can('create', 'Audience')
      can('read', ON_SITE_AD_SERVER_SETTINGS_PAGE)
    }
  } else if (accountType === PARTNER_TYPE) {
    can('manage', [PARTNER_FILE_TYPES_LIST, GAM_LINE_ITEM_ADVANCED_SETTINGS])
    can('read', [RIGHT])
    if (role === REPORT) {
    } else if (role === MANAGER) {
    } else if (role === ADMIN) {
      can('manage', ['SettingsPartnerTeam'])
    }
  }

  if (role === REPORT) {
  } else if (role === MANAGER) {
    can('read', ['Campaign'])
    can('update', ['Campaign'])
    can('delete', ['Campaign'])
    can('manage', ['LineItem', 'Ad', 'SettingsLocationLists'])
    can('manage', CALENDAR_EVENTS)
    can('manage', COMBINED_CAMPAIGN_EDIT)
  } else if (role === ADMIN) {
    can('read', ['Campaign'])
    can('update', ['Campaign'])
    can('delete', ['Campaign'])
    can('manage', ['LineItem', 'Ad', 'SettingsLocationLists'])
    can('manage', CALENDAR_EVENTS)
    can('manage', COMBINED_CAMPAIGN_EDIT)
  }

  return build()
}
